import React from 'react';
import { css } from 'aphrodite';

import GlobalStyles from 'components/common/styles/GlobalStyles';

interface Props {
  label: string;
  dataTestId: string;
  action: () => void;
}

const LinkButton: React.FC<Props> = ({ label, dataTestId, action }) => {
  return (
    <button
      className={`btn btn-link ${css(GlobalStyles.noPadding)}`}
      onClick={() => action()}
      data-testid={dataTestId}
    >
      {label}
    </button>
  );
};

export default LinkButton;
